import React, { useEffect, useState } from "react";
import API from "../../../services/api";
import { useAuth } from "../../../context/AuthContext";

const StaffDashboard = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get("/grievances/", { params: { page: 1, per_page: 100 } })
      .then((res) => {
        const grievances = res.data.data.grievances;
        const byStatus = {};
        grievances.forEach((g) => {
          byStatus[g.current_status] = (byStatus[g.current_status] || 0) + 1;
        });
        setStats({ total: grievances.length, byStatus });
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div className="mb-4">
        <h4 className="fw-bold mb-1">Welcome, {user?.name} 👋</h4>
        <p className="text-muted small mb-0">
          Staff Dashboard — Grievances assigned to you
        </p>
      </div>

      {loading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-info"></div>
        </div>
      ) : (
        <>
          <div className="row g-3 mb-4">
            <div className="col-6 col-md-3">
              <div className="card border-0 shadow-sm rounded-4 text-center p-3">
                <div className="fw-bold fs-3 text-primary">
                  {stats?.total || 0}
                </div>
                <div className="text-muted small">Total</div>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="card border-0 shadow-sm rounded-4 text-center p-3">
                <div className="fw-bold fs-3 text-warning">
                  {stats?.byStatus?.New || 0}
                </div>
                <div className="text-muted small">New</div>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="card border-0 shadow-sm rounded-4 text-center p-3">
                <div className="fw-bold fs-3 text-success">
                  {stats?.byStatus?.Resolved || 0}
                </div>
                <div className="text-muted small">Resolved</div>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="card border-0 shadow-sm rounded-4 text-center p-3">
                <div className="fw-bold fs-3 text-danger">
                  {stats?.byStatus?.Escalated || 0}
                </div>
                <div className="text-muted small">Escalated</div>
              </div>
            </div>
          </div>

          <div className="card border-0 shadow-sm rounded-4">
            <div className="card-body p-4">
              <h6 className="fw-semibold mb-3">
                <i className="bi bi-bar-chart me-2 text-info"></i>
                My Grievance Status
              </h6>
              {stats?.byStatus &&
                Object.entries(stats.byStatus).map(([status, count]) => (
                  <div key={status} className="mb-2">
                    <div className="d-flex justify-content-between small mb-1">
                      <span>{status}</span>
                      <span className="fw-semibold">{count}</span>
                    </div>
                    <div className="progress" style={{ height: "6px" }}>
                      <div
                        className="progress-bar bg-info"
                        style={{
                          width: `${(count / (stats.total || 1)) * 100}%`,
                        }}
                      ></div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default StaffDashboard;
